export default {
  all: [],
  distances: [],
  distance: [],
  current: null,
  updating: false,
  expires: null
};